export default {
  title: 'Mukautetut painotuotteet',
  fields: {
    name: 'Nimi',
    format: 'Tuotetyyppi',
  },
  buttons: {
    upload_product: 'Aloita lataus',
    preview: 'Esikatselu',
    edit: 'Muokkaa',
  },
};
